import { api } from '@api'
import { usePaginate } from './usePaginate'
import type { PaginatedResponse } from './types'
import type { Notification } from './types/notificationTypes'

/** Version of the Notifications page sent to the API (see GET /notifications). */
export const NOTIFICATIONS_PAGE_VERSION = '2'

type FetchParams = {
  pageParam?: string
  tab?: 'all' | 'requests' | 'agenda'
}

const fetchNotifications = async (
  params?: FetchParams,
): Promise<PaginatedResponse<Notification>> => {
  const queryParams = new URLSearchParams()
  if (params?.pageParam) queryParams.append('page', params.pageParam)
  if (params?.tab) queryParams.append('tab', params.tab)
  // Late follow-ups, accepted requests, sent messages, tomorrow's birthdays.
  queryParams.append('v', NOTIFICATIONS_PAGE_VERSION)
  const url = `/notifications${queryParams.toString() ? `?${queryParams.toString()}` : ''}`
  const { data } = await api.get<PaginatedResponse<Notification>>(url)
  return data
}

export const usePaginateNotifications = (tab: 'all' | 'requests' | 'agenda' = 'all') => {
  return usePaginate<Notification>(
    'notifications',
    fetchNotifications,
    { tab },
    // Keep the current list visible while switching tabs or refetching after a
    // push notification, instead of flashing an empty screen.
    { keepPreviousData: true },
  )
}
